import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
//plugins
import Toasted from 'vue-toasted'
import Tooltip from 'vue-directive-tooltip'
import VPopover from 'vue-js-popover'
import { VPopover as VPopoverTooltip, VClosePopover } from 'v-tooltip'
import VueSkeletonLoader from 'skeleton-loader-vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueTheMask from 'vue-the-mask';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
//utils
import './utils/validation-rules'
//styles
import './assets/styles/main.css'
import {Table, Switch, Pagination, Tabs} from "@oruga-ui/oruga"
import '@oruga-ui/oruga/dist/oruga.css'
import '@oruga-ui/oruga/dist/oruga-full-vars.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

// CASL
import { abilitiesPlugin } from '@casl/vue';
import defineAbilityFor from './services/defineAbilityFor';
import config from "@/utils/appConfig";

import { getNewTabHint } from '@/utils/text-formatter'

Vue.component('v-select', vSelect)
Vue.component('DatePicker', DatePicker)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.component('vue-skeleton-loader', VueSkeletonLoader);

Vue.use(config)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(VueCtkDateTimePicker)
Vue.use(Switch)
Vue.use(VueTheMask)

Vue.use(abilitiesPlugin, defineAbilityFor(), {
    useGlobalProperties: true
})

Vue.use(Toasted, {
  position: 'top-right',
  duration: 2000,
	keepOnHover: true,
	closeOnSwipe: true,
	iconPack : 'material',
})
const toastTypes = ['error', 'success', 'info']

Vue.use(Tooltip, {
  delay: 0,
  placement: 'right',
  class: 'gl-tooltip',
  triggers: ['hover', 'focus', 'click' ],
  offset: 10,
})

// vue-directive-tooltip swaps the text on update but never re-runs Popper, so a
// tooltip that is already open keeps the box position computed for its previous
// message. When the validation message shrinks (e.g. "Must be in the format…" →
// "Limit: 180d") the box stays anchored to the old left edge and looks shifted.
// Re-position whenever the bound content changes.
const tooltipDirective = Vue.directive('tooltip')
const tooltipComponentUpdated = tooltipDirective.componentUpdated
tooltipDirective.componentUpdated = function (el, binding, ...rest) {
  tooltipComponentUpdated.call(this, el, binding, ...rest)
  if (el.tooltip && binding.value?.content !== binding.oldValue?.content) {
    el.tooltip.tooltip.update()
  }
}

Vue.use(VPopover, { tooltip: true })

Vue.prototype.$newTabHint = getNewTabHint;

Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover-tooltip', VPopoverTooltip)

toastTypes.forEach(type => {
  Vue.toasted.register(
    type,
    ({ message }) => message || '',
    {
      type,
      className: `gl-toast gl-toast--${ type }`,
    })
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
